import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAvailableSolarEnergy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 37,
	height: 38,
	viewBox: "0 0 37 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5 0.500092C28.7173 0.500092 37 8.78282 37 19.0001C37 29.2174 28.7173 37.5001 18.5 37.5001C8.28273 37.5001 0 29.2174 0 19.0001C0 8.78282 8.28273 0.500092 18.5 0.500092ZM21 10.5001C20.6834 10.5001 20.4004 10.5922 20.1504 10.7755C19.9004 10.9588 19.7163 11.1915 19.5996 11.4747L15 23.5997L12.7002 17.5001H7V19.5001H11.2998L13.5996 25.5255C13.7163 25.8087 13.9004 26.0414 14.1504 26.2247C14.4004 26.408 14.6834 26.5001 15 26.5001C15.3166 26.5001 15.5996 26.408 15.8496 26.2247C16.0996 26.0414 16.2837 25.8087 16.4004 25.5255L21 13.4005L23.2998 19.5001H29V17.5001H24.7002L22.4004 11.4747C22.2837 11.1915 22.0996 10.9588 21.8496 10.7755C21.5996 10.5922 21.3166 10.5001 21 10.5001Z",
		fill: "{fill}"
	})
});
export default SvgAvailableSolarEnergy;
